import { CatalogItemKind } from 'fym-shared/src/smartlinks/catalog';
import { CatalogItem } from '../../../../../redux/api/fymAPI.types';
import { daysToRelease } from '../studioRules';
import { sortSongsForStudio } from '../sortSongsForStudio';

export interface PickerGroups {
  /** The songs before their release day, the nearest first. Unreleased songs with no date come last. */
  comingOut: CatalogItem[];
  /** The songs on or after their release day, the newest first. Released songs with no date come last. */
  outNow: CatalogItem[];
}

/** True when the song is not out yet. An unreleased song with no date is not out yet. */
export function isComingOut(item: CatalogItem, now: Date): boolean {
  const days = daysToRelease(item.releaseDate, now);
  if (days === null) {
    return item.kind === CatalogItemKind.unreleased;
  }
  return days > 0;
}

/** The two groups of the song picker (design t1), in the order of `sortSongsForStudio`. Pure. */
export function groupSongsForPicker(items: CatalogItem[], now: Date): PickerGroups {
  const sorted = sortSongsForStudio(items, now);
  return {
    comingOut: sorted.filter((item) => isComingOut(item, now)),
    outNow: sorted.filter((item) => !isComingOut(item, now)),
  };
}
